import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import login from './login'
import estabelecimentos from './estabelecimentos'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    login,
    estabelecimentos
  },
  strict: process.env.DEV,
})
